module.exports = __webpack_public_path__ + "img/image-plus.5792f0c1.svg";